import fullSuitSvg from "../../../assets/new-icons/services-business/fullsuite.svg";
import multiIndustrySvg from "../../../assets/new-icons/services-business/multi-industry.svg";
import secureSvg from "../../../assets/new-icons/services-business/secure.svg";
import tailorfittedSvg from "../../../assets/new-icons/services-business/tailorfitted.svg";
import dedicatedTeamSvg from "../../../assets/new-icons/services-business/dedicatedteam.svg";

export const BusinessData = [
  {
    heading: "Full-Suite Translation Solutions for Businesses",
    para: "Whether your business translation incorporates emails, financial documents, legal agreements, marketing materials, employment contracts, or any other kind of business document, we provide outstanding translation and localization services. We work closely with your company every step of the way.",
    img_link: "",
    icon: fullSuitSvg,
  },
  {
    heading: "Multi-Industry Expertise",
    para: "Our business translators are highly experienced, qualified linguists who are used to working to strict deadlines for clients around the globe. We have worked with over 50,000 business clients, from micro-businesses to Fortune 500 companies. We deliver the same diligence and superb customer care to every client.",
    img_link: "",
    icon: multiIndustrySvg,
  },
  {
    heading: "Secure and Efficient",
    para: "Tomedes provides secure and efficient services for every translation project, so your corporation can rest assured. We use end-to-end encryption for all files, and our translators and project managers are under NDAs to further protect your information. We treat your files and information with the utmost care and confidentiality.",
    img_link: "",
    icon: secureSvg,
  },
  {
    heading: "Tailor-Fitted for Your Needs",
    para: "If your venture needs smart human solutions, we're here for you. But if you're also looking for machine translations and post-editing solutions, Tomedes is tailor-fitted for your needs. Our customer support is 24/7 and ready to handle any requests you may have, such as on-demand translations, real-time interpretation, and highly specialized localizations.",
    img_link: "",
    icon: tailorfittedSvg,
  },
  {
    heading: "Dedicated Team",
    para: "At Tomedes, you can be assured of a dedicated team to go along with your business translation services. This team is a hand-picked selection of project and account managers along with your own personal pool of translators. We at Tomedes firmly believe that the client is at the heart of our business philosophy, which is why we have a 97% client satisfaction rate. Could you ask for anything more?",
    img_link: "",
    icon: dedicatedTeamSvg,
  },
];

export const BusinessConfigData = [
  {
    title: "Marketing Translation Services",
    detail:
      "Execute your marketing campaigns in over 120 languages. You can boost your rankings with our multilingual SEO, our inbound and outbound marketing campaigns for multilingual websites, and our full range of translation, localization, and interpretation, for your website, app, or game.",
    link: "/marketing-translation.php",
  },
  {
    title: "Legal Translation Services",
    detail:
      "For legal translation, it's necessary to have the skill of a legal translator, to translate and adapt your legal documents for your applicable needs. Such documents include contracts, briefs, agreements, and more. Our legal translators in our legal translation services have the industry experience and expertise of the legal field.",
    link: "/legal-translation.php",
  },
  {
    title: "Financial Translation Services",
    detail:
      "For all your financial transactions, financial websites, and financial documents, there's a financial translator waiting for you at Tomedes. If you're an accounting firm, a cryptocurrency firm, or an eCommerce firm, you'll receive quality translations of your balance sheets, cash flow statements, income statements, and others.",
    link: "/financial-translation.php",
  },
  {
    title: "Medical Translation Services",
    detail:
      "At Tomedes, our medical translation services include the first-rate expertise of the best medical translators and interpreters. Medical translations are key to running an international MedTech, hospital, or clinic business, while medical interpretation can assist patients and providers for communication purposes at any stage of the patient's journey.",
    link: "/medical-translation.php",
  },
  {
    title: "Localization Services",
    detail:
      "For any international business, localization is a must. A truly globalized multinational company must start local, providing localized marketing, localized apps, or localized games to their consumers. Through translation and localization, Tomedes translators and localizers work together to ensure results in your business' international expansion.",
    link: "/localization-services.php",
  },
  {
    title: "Interpreting Services",
    detail:
      "In order to assist more fully in the interpretation process, communication is key. At Tomedes, we offer comprehensive consecutive and simultaneous interpretation services to create pathways in the consumer's journey, be it in financial transactions, legal services, or in the medical field.",
    link: "/interpretation-services",
  },
];
